import { initializeAllDropdownSelects } from "./dropdown-select";

initializeAllDropdownSelects();
